<template>
    <div>
        <v-card  max-width="700px">
            <v-toolbar flat>
                <v-toolbar-title> Αλλαγή κωδικού</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-alert color="info lighten-3" v-if="showAlert"> Επειδή συνδέεστε για πρώτη φορά, πρέπει να αλλάξετε
                    τον προκαθορισμένο
                    κωδικό που σας
                    δόθηκε με έναν δικό σας
                </v-alert>
                <v-alert color="error lighten-3" v-if="error!==''"> {{error}}</v-alert>
                <v-form
                        v-model="valid"
                >
                    <v-text-field v-model="oldPassword" :rules="oldPasswordRules" label="Παλιός κωδικός"
                                  type="password"/>
                    <v-text-field v-model="newPassword" :rules="newPasswordRules" label="Καινούριος κωδικός"
                                  type="password"/>
                    <v-text-field v-model="repeatPassword" :rules="[checkPassword]" label="Επανάληψη κωδικού"
                                  type="password"/>
                    <v-btn :disabled="!valid" color="primary"
                           @click="onChangePassword({newPassword:newPassword,oldPassword:oldPassword})"> Αλλαγή κωδικού
                    </v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </div>

</template>

<script>
    import {mapActions, mapMutations} from 'vuex'

    export default {
        name: "ChangePassword",
        data: () => ({
            valid: true,
            error: '',
            oldPassword: '',
            newPassword: '',
            repeatPassword: '',
            oldPasswordRules: [
                v => !!v || 'Ο παλιός κωδικός απαιτείτε',
            ],
            newPasswordRules: [
                v => v.length >= 8 || 'Ο κωδικός πρέπει να είναι από 8 χαρακτηρήρες και πάνω.',
                v => /\d/.test(v) || 'Ο κωδικός απαιτεί εναν αριθμό.',
                v => /[a-zA-Z]/.test(v) || 'Ο κωδικός απαιτεί ενα γράμμα.'
            ],
        }),
        props: {
            showAlert: Boolean
        },
        computed: {
            checkPassword() {
                return this.repeatPassword === this.newPassword || 'ο κωδικός δεν έιναι ο ίδιος με αυτόν που πληκτρολογήσατε'
            }
        },
        methods: {
            onChangePassword(details) {
                this.changePassword(details).catch(
                    err => {
                        this.error = err.ErrorDetails;
                        this.hideLoading();
                    }
                )
            },
            ...mapMutations([
               "hideLoading"
            ]),
            ...mapActions([
                "changePassword"
            ])
        }
    }
</script>

<style scoped>

</style>
